<template>
  <div class="animated fadeIn">
    <b-card v-if="showList">
      <div slot="header">Accrued - Reguler Cost 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-dropdown text="Reverse" variant="primary mr-1" >
            <b-dropdown-item @click="reverse" :disabled="!(model)">Reverse 1 record</b-dropdown-item>
            <b-dropdown-item @click="reverseselected" :disabled="(selected.length==0)">Reverse Selected {{selected.length}} records </b-dropdown-item>
          </b-dropdown>
          <b-dropdown text="Print" variant="primary mr-1" >
            <b-dropdown-item @click="printjv" >Print Accrued JV</b-dropdown-item>
            <b-dropdown-item @click="printjv_reverse" :disabled="(model.reversed == 0)">Print Reverse JV</b-dropdown-item>
          </b-dropdown>

          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
          <b-col cols="5">
            <b-input-group >
              <b-input-group-prepend><label>Accured Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
            </b-input-group>
          </b-col>
          <b-col cols="5">
            <b-input-group >
              <b-input-group-prepend><label>Reverse Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tglr1" type="date"></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tglr2" type="date"></b-form-input>
            </b-input-group>
          </b-col>
      </b-row>      


      <b-row >
        <b-col lg="5">
            <b-input-group >
                 <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.keterangan" placeholder="Description"></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group >
              <b-input-group-prepend><label>Debit Account</label></b-input-group-prepend>
              <b-form-input v-model="tblData.kodeacc" placeholder="Account Code" style="width:15% !important"></b-form-input>
              <b-form-input v-model="tblData.namaacc" placeholder="Account Name" class="ml-1" style="width:35% !important"></b-form-input>                
              <b-input-group-prepend><span class="p-2">Reversed</span></b-input-group-prepend>
              <b-form-select v-model="tblData.reversed" :plain="true" :options="YesNoAll"></b-form-select>
          </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
              <b-form-input v-model="tblData.vendor" placeholder="Vendor/Supplier"></b-form-input>
              <b-input-group-append>
                  <b-button class="btn btn-success ml-3" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
              </b-input-group-append>
              <b-input-group-append>
                <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="tblAccuredJv"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(selected)="data">
             <input
            name="selectjurnal"
            type="checkbox"
            @change="checkedjurnal($event,data.item)"
            :data-accrujvkey="data.item.accrujvkey"
            :checked="ischeckedjurnal(data.item.accrujvkey)"
            :disabled="(data.item.reversed===1)"
          />
        </template>
        <!-- A custom formatted header cell for field 'name' -->
        <template v-slot:head(selected)="data">
                  <a href="javascript:void(0)" class="text-danger" @click="checkedclear()">
                    <i class="fa fa-eraser"></i>
                  </a>
        </template>        
        <template v-slot:cell(reversed)="data">
          <div v-if="data.item.reversed==0" style="background-color:yellow;">           
             No
          </div>
          <div v-else> Yes </div>
        </template>
        <template v-slot:cell(reversdate)="data">
          <span v-if="(data.item.reversdate)"> {{data.item.reversdate| moment("DD MMM YYYY")}} </span>
        </template>

        <template v-slot:cell(tanggal)="data">
          {{data.item.tanggal| moment("DD MMM YYYY")}}
        </template>
        <template v-slot:cell(nilai)="data">
          {{data.item.nilai|numFormat}}
        </template>
        <template v-slot:cell(Dim1)="data">
          <span v-if="(data.item.Dim1)">{{data.item.Dim1}} | {{data.item.Dim1Txt}}</span>
        </template>
        <template v-slot:cell(Dim2)="data">
          <span v-if="(data.item.Dim2)">{{data.item.Dim2}} | {{data.item.Dim2Txt}}</span>
        </template>
        <template v-slot:cell(Dim3)="data">
          <span v-if="(data.item.Dim3)">{{data.item.Dim3}} | {{data.item.Dim3Txt}}</span>
        </template>
        <template v-slot:cell(Dim4)="data">
          <span v-if="(data.item.Dim4)">{{data.item.Dim4}} | {{data.item.Dim4Txt}}</span>
        </template>
        <template v-slot:cell(Dim5)="data">
          <span v-if="(data.item.Dim5)">{{data.item.Dim5}} | {{data.item.Dim5Txt}}</span>
        </template>
        <template v-slot:cell(Dim6)="data">
          <span v-if="(data.item.Dim6)">{{data.item.Dim6}} | {{data.item.Dim6Txt}}</span>
        </template>

      </b-table>
      <b-row >
        <b-col cols="4">
          <div class="pt-1">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="5">          
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit2" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit2} records`" style="max-width:80px; !important;"></b-form-input>  
              <b-pagination
                v-if="pagination" 
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
          </b-input-group>
        </b-col>
        <b-col cols="3" >
          <div class="text-right pt-1">
            <span style="background-color:yellow;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="mr-2">Accrued Not REVERSED yet</span>
          </div>
        </b-col>        
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>

    <b-card v-if="showForm">
      <div slot="header">Accrued Process Form 
        <div class="card-header-actions">
          <div style="width:530px; !important; ">
            <b-input-group >
              <b-input-group-prepend><span class="p-2">Accured Date:</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tanggal" type="date"></b-form-input>
              <b-input-group-append>
                  <button class="btn btn-primary mr-1" @click="save()" v-if="saveEnabled"> <i class="fa fa-save"></i> Save </button>
              </b-input-group-append>
              <b-input-group-append>
                  <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
              </b-input-group-append>

            </b-input-group>
          </div>  
        </div>
      </div>
            <b-row v-if="(filterShow=='Hide')">
              <b-col lg="5">
                  <b-input-group size="sm" class="ml-1">
                      <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch></b-form-checkbox>
                        <b-input-group-prepend> <span class="pr-2">
                            <b> {{ filterShow }}</b>  Filter </span>
                        </b-input-group-prepend>
                      <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                  </b-input-group>
              </b-col>
              <b-col lg="7">
                  <b-input-group size="sm" >
                      <b-input-group-prepend > <span class="p-1">Filter On:</span>
                      </b-input-group-prepend>
                      <b-form-checkbox-group v-model="filterOn" class="mt-1">
                          <b-form-checkbox value="uraian">Description</b-form-checkbox>
                          <b-form-checkbox value="vendorinfo">Vendor/Supplier</b-form-checkbox>
                          <b-form-checkbox value="db_kodeacc">DB Account#</b-form-checkbox>
                          <b-form-checkbox value="db_namaacc">DB Account Name</b-form-checkbox>
                      </b-form-checkbox-group>
                  </b-input-group>
                  <label class="text-muted small" style="margin-left:100px;">Leave all unchecked to filter on all data</label>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="ml-3">
                <b> {{ filterShow }}</b>  Filter
              </b-form-checkbox>
            </b-row>

  <!-- Gunakan properti sticky-header pada b-table untuk membuat judul kolom tidak ikut bergerak saat di scroll          
  sticky-header="600px" -->
        <b-table
          class="mb-0"
          ref="tableOri"
          outlined
          responsive
          striped
          hover
          style="font-size: smaller"
          :items="accrutmps"
          :fields="accrutmpFields"
          :current-page="tblTemp.page"
          :per-page="tblTemp.limit"
          :sort-by.sync="tblTemp.sortBy"
          :sort-desc.sync="tblTemp.sortDesc"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
        >
          <template v-slot:cell(terpilih)="data">
              <b-form-checkbox
                v-model="data.item.terpilih"
                style="width:20px;"
                value=1 unchecked-value=0 @change="calcTotalAccruedFrm"
              ></b-form-checkbox>
          </template>
          <template v-slot:cell(nilai)="data">
            {{ data.item.nilai | numFormat }}
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="5">
            <b-input-group class="mr-2">
                <b-input-group-prepend><span class="p-2">Total Data Accrued</span></b-input-group-prepend>
                  <my-number v-model="totalRecord" readonly class="form-control text-right"  separator="," ></my-number>
                <b-input-group-prepend><span class="input-group-text">records</span></b-input-group-prepend>
                <b-input-group-prepend><span class="p-2">&nbsp;&nbsp;&nbsp; Total Amount Accrued</span></b-input-group-prepend>
                <b-input-group-prepend><span class="input-group-text">{{ uanguser }}</span></b-input-group-prepend>
                  <my-number v-model="totalAmount" readonly class="form-control text-right" :precision="2"  separator="," style="width:28% !important;" ></my-number>
            </b-input-group>
          </b-col>
          <b-col cols="7">
            <b-row>
              <b-col cols="6" style="text-align: center">
                <div>
                  Showing {{ (tblTemp.page - 1) * tblTemp.limit + 1 }} to
                  <span v-if="tblTemp.page * tblTemp.limit > tblTemp.total">{{
                    tblTemp.total
                  }}</span>
                  <span v-else>{{ tblTemp.page * tblTemp.limit }}</span> of
                  {{ tblTemp.total }} entries
                </div>
              </b-col>
              <b-col cols="6">
                <b-input-group>
                    <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
                    <b-form-input v-model="limit" type="number" class="mr-2"></b-form-input>  
                    <b-pagination
                      align="right"
                      :total-rows="tblTemp.total"
                      :per-page="tblTemp.limit"
                      v-model="tblTemp.page"
                    ></b-pagination>
                </b-input-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
  </div>
</template>



<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueMonthlyPicker from 'vue-monthly-picker';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import toastr from "mini-toastr";
import moment from 'moment';
import accrued from "../../apis/accrued";
import dropdown from "../../data/dropdown";

import { validationMixin } from "vuelidate";
import { required, minValue, maxLength, numeric } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        accrujvkey: { required },
        accrutmpkey: { required },
        uraian: { required },
        vendor: { required },
        db_kodeacc: { required },
        kr_kodeacc: { required },
        nilai: { required, minValue:minValue(1) },
        nomorjv: { required },
    },
  }, 
  data() {
    return {
      pagination:false,
      showDelConfirm: false,
      saveEnabled:true,
      isLoading: false,
      showList:true,
      showForm:false,
      showEdit:false,
      showFilter:false,
      lkuCoaShow:false,
      lkuCoaCaller:'debit',
      lkuVendorShow:false,
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      monthLabels:dropdown.monthLabels,
      YesNoAll: dropdown.YesNoAll,
      accrutmps:[],
      model:{},
      frmdata:{accrujvkey:'',accrutmpkey:'', jmlaccru:1},
      limit2:100,
      tblData: {
        items: [],
        page: 1,
        limit: 100,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln,        
        tanggal:this.$store.state.user.akhirbln,        
        DimCol:'Dim1',
        sortBy: 'nomorjv',
        sortDesc: false,
        periode: this.$store.state.user.tglaktif.substring(0,7)
      },
      selected:[],
      filterShow: "Show",
      filter: null,
      filterOn: [],
      tblTemp: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: "db_kodeacc",
        sortDesc: false
      },
      limit:20,
      totalRecord:0, totalAmount:0,
      uanguser: this.$store.state.user.matauang,
    };
  },
  components: {Loading, VueMonthlyPicker,myNumber, vDim},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "JV Date",
            sortable: true
          },
          {
            key: "nomorjv",
            thStyle: "width:100px",
            label: "JV Number",
            sortable: true
          },
          {
            key: "dbAccount",
            label: "DB Account#",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
            sortable: true
          },
          {
            key: "vendorinfo",
            label: "Supplier/Vendor",
            sortable: true
          },
          {
            key: "nilai",
            label: "Nilai Accrued",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "reversed",
            label: "Reverse",
            thStyle: "width:40px",
            thClass:"text-center",
            tdClass:"text-center",
            sortable: true
          },
          {
            key: "reversdate",
            label: "Reverse Date",
            thStyle: "width:90px",
            thClass:"text-center",
            tdClass:"text-center",
            sortable: true
          },
          {
            key: "reversedjv",
            label: "Reverse JV",
            thClass:"text-center",
            tdClass:"text-center",
            sortable: true
          },
          {
            key: "selected",
            label: "",
            thStyle: "width:20px",
            thClass:"text-center",
            tdClass:"text-center",
          },
          {
            key: "krAccount",
            label: "CR Account#",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: dims[i].value,
            thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }

      return fields;
    },
    accrutmpFields(){
      const fields=[
          {
            key: "uraian",
            label: "Description",
            sortable: true
          },
          {
            key: "vendorinfo",
            label: "Supplier/Vendor",
            sortable: true
          },
          {
            key: "terpilih",
            label: "Accrued",
            thClass: "text-center",
            sortable: true
          },
          {
            key: "nilai",
            label: "Cost/Month",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "dbAccount",
            label: "DB Account#",
            sortable: true
          },
          {
            key: "krAccount",
            label: "CR Account#",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}info`,
            thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }

      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        // this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblTemp.limit=newVal;
        }
      }, 500);
    } ,   
    limit2: function (newVal){
      setTimeout(() => {
        if (this.limit2==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    }    
  },
  // created: function (){
  //   // this.tblData.periode = this.$store.state.user.tglaktif.substring(0,7);
  //   this.tblData.tanggal = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD');
  // },  
  methods: {
    ischeckedjurnal(val){
      const findjv = this.selected.find(x => x === val);
      if(findjv){
        return 'checked'
      }else{
        return '';
      }
    },
    checkedclear() {
      this.selected = [];

      const checkBoxes = document.querySelectorAll('[name="selectjurnal"]') || [];
      checkBoxes.forEach(element => {
        element.checked= false;
      });
      // // uncheck setelah posting selected
      // $('[name="selectjurnal"]').each(function() {
      //     $(this).prop("checked", false);
      //   });
    },
    checkedjurnal(item,record) {
      this.rowClicked(record);
      const accrujvkey = item.target.attributes["data-accrujvkey"].value;
      if (item.target.checked) {
        const findjv = this.selected.find(x => x === accrujvkey);
        if (!(findjv)){
          this.selected.push(accrujvkey);
        }
      } else {
        const findIdx = this.selected.findIndex(x => x === accrujvkey);
        this.selected.splice(findIdx, 1);
      }
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.tblTemp.total = filteredItems.length;
    },
    data: async function(ctx) {
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        // toastr.info('Loading Accrued Transaction');
        const list = await accrued.trxlist(this.tblData);      
        return list;
    },
    refresh(ctx) {
      if (this.$refs.tblAccuredJv)  this.$refs.tblAccuredJv.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.kodeacc= '';
        this.tblData.namaacc=  '';
        this.tblData.keterangan=  '';
        this.tblData.vendor=  '';
        this.tblData.DimVal=  '';
        this.tblData.tgl1='';
        this.tblData.tgl2='';
        this.tblData.tglr1='';
        this.tblData.tglr2='';
        this.$forceUpdate();
        // this.refresh();
    },
    add: async function(data) {
      toastr.info('Loading Accrued Template');
      this.isLoading=true;
      try {
          this.accrutmps= await accrued.accruedtempwhactual(this.tblData);
          this.tblTemp.total=this.accrutmps.length;
          this.isLoading=false;
          this.showForm=true;
          this.showList=false;
      } catch (error) {
          console.log('error : ', error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }   
          this.isLoading=false;            
      }

    },
    calcTotalAccruedFrm: function(){
      setTimeout(() => {
          this.totalRecord= this.accrutmps.filter(a => a.terpilih == 1).length;
          this.totalAmount= this.accrutmps.filter(a => a.terpilih == 1).reduce(
                (a, b) => a + b.nilai,0);
      }, 500);
    },
    save: async function () {
        // if (!this.saveEnabled) {
        //     return;
        // }
            this.isLoading=true;            
            try {
              const data = { tanggal : moment(this.tblData.tanggal).format('YYYY-MM-DD') };
              // const data = { tanggal : this.tblData.tanggal };

              // let  newItem;         
              // data.lines = this.accrutmps.reduce((newArr, item) => {
              //   if (item.terpilih == 1) {
              //     newItem = {
              //       accrutmpkey: item.accrutmpkey || "",
              //       uraian: item.uraian,
              //       vendor: item.vendor,
              //       db_kodeacc: item.db_kodeacc,
              //       db_namaacc: item.db_namaacc,
              //       kr_kodeacc: item.kr_kodeacc,
              //       kr_namaacc: item.kr_namaacc,
              //       nilai: item.nilai
              //     };

              //     // newItem.DimTableKey= item.DimTableKey || ""
              //     this.dimension.forEach((dim) => {
              //       if (item[dim.value]) {
              //         newItem[dim.value] = item[dim.value];
              //         newItem[`${dim.value}Txt`] = item[`${dim.value}Txt`];
              //       }
              //     });
              //     newArr.push(newItem);
              //   }
              //   return newArr;
              // }, []);
              data.lines = this.accrutmps.filter(a => a.terpilih == 1);
              if (data.lines.length>0) {
                toastr.info('Save in progress');
                const hasil = await accrued.trxinsert(data);
                toastr.success(`Success, Trx.Number ${hasil.nomorjv}`, "Accrued Jurnal",10000);
                this.isLoading=false;            
                this.closeFrm();              
                setTimeout(() => {
                    this.refresh();              
                }, 500);       
              } else {
                    toastr.error('No selected data tobe saved');
              }
              this.isLoading=false;            
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.isLoading=false;            
            }
    },    
    rowRevers: function(record){
      this.rowClicked(record);
      this.reverse();
    },   
    reverse: async function()
    {
      if (this.model.accrujvkey) {
        this.isLoading=true;
          try {
              const result = await accrued.reverse(this.model);
                this.isLoading=false;            
              this.model.reversed= 1;
              this.model.reversdate= result.reversdate;
              toastr.success(`Success, Trx.Number ${result.nomorjv}`, "Accrued Jurnal",10000);
              this.checkedclear();
          } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.isLoading=false;            
          }
        } else {
            toastr.warn('Please select a row that want to be reversed!');
        }
        this.isLoading=false;
    },
    reverseselected: async function()
    {
      if (this.selected) {
          this.isLoading=true;
          try {
              const result = await accrued.reverseselected(this.selected);
              this.selected=[];
                this.isLoading=false;            
              toastr.success(`Success, Trx.Number ${result.nomorjv}`, "Accrued Jurnal",10000);
              this.refresh();
              // this.checkedclear();
          } catch (error) {
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
          this.isLoading=false;
        } else {
            toastr.warn('Please select row(s) that want to be reversed!');
        }
    },

    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await accrued.trxexport(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },
    printjv: async function()
    {
       if (this.model.advanKey) {
          try {              this.showReport=true;

              this.reportUrl= await accrued.printjv({ nomor: this.model.nomorjv, tanggal:moment(this.model.tanggal).format('YYYY-MM-DD'), kodejurnal: 'JV'});

          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
          toastr.warn('Please select one Data taht want to print ');
        }
    },
    printjv_reverse: async function()
    {
       if (this.model.advanKey) {
          try {              this.showReport=true;

              this.reportUrl= await accrued.printjv({ nomor: this.model.reversedjv, tanggal:moment(this.model.reversdate).format('YYYY-MM-DD'), kodejurnal: 'JV'});

          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
          toastr.warn('Please select one Data taht want to print ');
        }
    },

    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await accrued.trxremove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
        if (this.lkuCoaCaller==='debit'){
            this.frmdata.dbAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.frmdata.db_kodeacc = _selected.kodeacc;
            this.frmdata.db_namaacc = _selected.namaacc;
        } else {
            this.frmdata.krAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.frmdata.kr_kodeacc = _selected.kodeacc;
            this.frmdata.kr_namaacc = _selected.namaacc;
        }
        this.lkuCoaShow=false;
    },
    onSelectLkuVendor(_selected) {
        this.frmdata.vendorinfo = _selected.vendor_name.trim() + ' | ' + _selected.vendor_code.trim();
        this.frmdata.vendor = _selected.vendor_code;
        this.lkuVendorShow=false;
    },
    closeFrm(){
      this.showForm=false;
      this.showEdit=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
